import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWallet';
import Launch from '@material-ui/icons/Launch';
import People from '@material-ui/icons/People';
import Receipt from '@material-ui/icons/Receipt';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { SectionIntro } from '@univerus/plugin-products';
import { ShortcutTile } from './ShortcutTile';
import { safeExternalUrl } from './contentModel';
import { useHomeStyles } from './homeStyles';

const ICONS: Record<string, JSX.Element> = {
  payroll: <AccountBalanceWallet />,
  people: <People />,
  expenses: <Receipt />,
};

/** The Employee tools list, from app.employeeTools; hidden when none are set. */
export function EmployeeTools() {
  const classes = useHomeStyles();
  const config = useApi(configApiRef);
  const tools = (config.getOptionalConfigArray('app.employeeTools') ?? [])
    .map(tool => ({
      label: tool.getString('label'),
      url: safeExternalUrl(tool.getString('url')),
      detail: tool.getOptionalString('detail'),
      icon: tool.getOptionalString('icon'),
    }))
    .filter(tool => tool.url);
  if (!tools.length) return null;
  return (
    <section className={classes.section} aria-labelledby="tools-title">
      <div className={classes.sectionHead}>
        <SectionIntro size="section" id="tools-title" title="Employee tools">
          Pay, time off and expenses.
        </SectionIntro>
      </div>
      <nav className={classes.tools} aria-label="Employee tools">
        {tools.map(tool => (
          <ShortcutTile
            key={tool.url}
            variant="row"
            to={tool.url!}
            label={tool.label}
            icon={(tool.icon && ICONS[tool.icon]) || <Launch />}
            detail={tool.detail}
            external
          />
        ))}
      </nav>
    </section>
  );
}
